<div class="view-register__main">
  <div class="view-register-section">
    <div class="view-register-management-section">
            <app-list-page-header [headerTitle]="(materialList?.shipmentType ? materialList.shipmentType : '') + ' ' + 
            (materialList?.shipmentMode ? materialList.shipmentMode : '')"
      ></app-list-page-header>
      @if (!isModal) {
        <div>
          <app-common-button buttonClass="smallbutton" (clickEvent)="back()" buttonLabel="Back">
          </app-common-button>
        </div>
      }
      @if (isModal) {
        <div>
          <app-common-icon [faIcon]="faDownload" [ngbTooltip]="'Download'" [placement]="'bottom'" class="downloadButton"
            (clickEvent)="downloadSheet()" [loadingIcon]="loadingRecords">
          </app-common-icon>
        </div>
      }
    </div>
    <div>
      <div class="view-register-details__detailscard">
        <div class="viewcontractDetail d-flex justify-content-between align-items-center search-by w-100">
          <div class="view-register-details__detailscardfield">
            <div class="view-register-details__detailscardfield-description mb-2">
              Unique ID
            </div>
            <div class="view-register-details__detailscardfieldheading">
              {{ materialList?.uniqueId }}
            </div>
          </div>
          <div class="view-register-details__detailscardfield">
            <div class="view-register-details__detailscardfield-description mb-2">
              Status
            </div>
            <div class="view-register-details__detailscardfieldheading"
              [ngStyle]="getStatusStyle(materialList?.status)">
              {{ materialList?.status }}
            </div>
          </div>
          @if (!isModal) {
            <div class="d-flex text-right">
              <div (click)="isEdit()">
                @if ((materialList?.status === 'Pending Document Upload' || materialList?.status === 'Pending Correction') && (!isPrimary && !selectedCompanyId)) {
                  <app-common-icon [faIcon]="faPen" [placement]="'top'" appAccessControl
                    allowedRoles="mr-outbound.update"
                  class="btn btn-primary btn-sm me-2 custom-disable" ngbTooltip="Edit"></app-common-icon>
                }
              </div>
              <div (click)="isUploadDocument()">
                @if ((materialList?.status === 'Pending Document Upload') && (!isPrimary && !selectedCompanyId)) {
                  <app-common-icon [faIcon]="faCloudUploadAlt" [placement]="'top'" appAccessControl
                    allowedRoles="mr-outbound.upload"
                    class="btn btn-primary btn-sm me-2 custom-disable"
                  ngbTooltip="Upload"></app-common-icon>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="view-register-details__DescriptionWrapper">
        <div class="view-register-details__DescriptionContainer">
          <div class="d-flex justify-content-between border-bottom">
            <div class="view-register-details__DescriptionHeader mb-2">
              Transporter Details
            </div>
          </div>
          <div class="view-register-details">
            <div class="view-register-details__detailscardfield">
              <div class="view-register-details__detailscardfield-description mb-2">
                {{ materialList?.shipmentMode === 'Export' ? 'Freight Forwarder' : 'Transporter Name' }}
              </div>
              <p class="view-register-details__detailscardfieldheading uppercase-text">
                {{ materialList?.shipmentMode === 'Export' ? materialList?.freightForwarder : materialList?.transporter }}
              </p>
            </div>
            <div class="view-register-details__detailscardfield">
              <div class="view-register-details__detailscardfield-description mb-2">
                Truck Number
              </div>
              <p class="view-register-details__detailscardfieldheading uppercase-text">
                {{ materialList?.truckNo }}
              </p>
            </div>
            @if (materialList?.shipmentMode === 'Export') {
              <div class="view-register-details__detailscardfield">
                <div class="view-register-details__detailscardfield-description mb-2">
                  Transporter Name
                </div>
                <p class="view-register-details__detailscardfieldheading uppercase-text">
                  {{ materialList?.subTransporter || "-" }}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="view-register-details__DescriptionWrapper">
        <div class="view-register-details__DescriptionContainer">
          <div class="d-flex justify-content-between border-bottom">
            <div class="view-register-details__DescriptionHeader mb-2">
              Transaction Details
            </div>
          </div>
          <div class="view-register-details__table">
            <div class="view-register-details__row header">
              <div class="view-register-details__detailscardfield-description">LR Number</div>
              <div class="view-register-details__detailscardfield-description">Customer Details</div>
              <div class="view-register-details__detailscardfield-description">Invoice Number</div>
              <div class="view-register-details__detailscardfield-description">Eway Bill</div>
              <div class="view-register-details__detailscardfield-description">Invoice Date</div>
              <div class="view-register-details__detailscardfield-description">Handling Units
                <span class="handling-unit-info" placement="top" data-bs-toggle="tooltip" [ngbTooltip]="handlingUnitsTooltip">
                  <app-common-icon [faIcon]="faInfoCircle"></app-common-icon>
                </span>
                <ng-template #handlingUnitsTooltip>
                  <div class="handling-units-tooltip">
                    <strong>Handling Unit Codes</strong>
                    <ul class="mb-0 mt-1">
                      <li>B – Boxes</li>
                      <li>P – Pallets</li>
                      <li>BN – Bins</li>
                      <li>T – Trolleys</li>
                      <li>D – Dollies</li>
                    </ul>
                  </div>
                </ng-template>
              </div>
            </div>
            @for (lr of materialList?.lrData; track lr) {
              <div class="view-register-details__row">
                <div class="view-register-details__detailscardfieldheading uppercase-text">{{ lr?.lrNo || "-" }}
                </div>
                <div class="view-register-details__detailscardfieldheading">
                  @for (customer of lr.customer; track customer; let last = $last) {
                    <span class="view-register-details__detailscardfieldheading uppercase-text"
                      >
                      {{ customer }} @if (!last) {
                      <br>
                      }
                    </span>
                  }
                </div>
                <div class="view-register-details__detailscardfieldheading">
                  @for (invoice of lr.invoice; track invoice; let last = $last) {
                    <span class="view-register-details__detailscardfieldheading uppercase-text"
                      >
                      {{ invoice }} @if (!last) {
                      <br>
                      }
                    </span>
                  }
                </div>
                <div class="view-register-details__detailscardfieldheading">
                  @for (eWayBill of lr.eWayBill; track eWayBill; let last = $last) {
                    <span class="view-register-details__detailscardfieldheading uppercase-text"
                      >
                      {{ eWayBill|| "-" }} @if (!last) {
                      <br>
                      }
                    </span>
                  }
                </div>
                <div class="view-register-details__detailscardfieldheading">
                  @for (date of lr.invoiceDate; track date; let last = $last) {
                    <span class="view-register-details__detailscardfieldheading uppercase-text"
                      >
                      {{ date | date:"dd-MMM-yy" }} @if (!last) {
                      <br>
                      }
                    </span>
                  }
                </div>
                <div class="view-register-details__detailscardfieldheading uppercase-text">
                  @if (lr?.totalBoxes) {
                    {{ lr?.totalBoxes }}/B
                  }
                  @if (lr?.palletBoxes) {
                    {{ lr?.palletBoxes }}/P
                  }
                  @if (lr?.bins) {
                    {{ lr?.bins }}/BN
                  }
                  @if (lr?.trolleys) {
                    {{ lr?.trolleys }}/T
                  }
                  @if (lr?.dollies) {
                    {{ lr?.dollies }}/D
                  }
                  @if (!(lr?.totalBoxes || lr?.palletBoxes || lr?.bins || lr?.trolleys || lr?.dollies)) {
                    -
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="view-register-details__DescriptionWrapper">
        <div class="view-register-details__DescriptionContainer">
          <div class="row d-flex justify-content-between border-bottom">
            <div class=" col-md-5 view-register-details__DescriptionHeader mb-2">
              Uploaded Documents
            </div>
            <div class="col-md-7">
              Material Register Logs
            </div>
          </div>
          <div class="ownership-document document-container">
            @if (fileDetails && materialList?.status !== 'Pending Document Upload') {
              <div class="toolbar">
                @if (!isLoading && !isModal) {
                  <button (click)="downloadDocument()">
                    <fa-icon [icon]="faDownload"></fa-icon>
                  </button>
                }
                @if (isLoading && !isModal) {
                  <button disabled>
                    <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                  </button>
                }
                @if (!isModal) {
                  <button (click)="openDocumentPopup()">
                    <fa-icon [icon]="faExpand"></fa-icon>
                  </button>
                }
              </div>
            }
            @if (fileDetails && materialList?.status !== 'Pending Document Upload') {
              <div class="ownership-document--body">
                @if (materialList.isImage && !materialList.isTiff) {
                  <img [src]="materialList.documentThumbnailUrl" alt="Document Preview"
                    class="ownership-document--body__Image">
                  } @else {
                    <img [src]="fileDetails.isPdf ? fileDetails.thumbnailUrl : '../../../assets/Images/document-preview/Files.svg'"
                      alt="Document Thumbnail" class="ownership-document--body__Image">
                    }
                    <ng-template #otherFile>
                      <img [src]="fileDetails.isPdf ? fileDetails.thumbnailUrl : '../../../assets/Images/document-preview/Files.svg'"
                        alt="Document Thumbnail" class="ownership-document--body__Image">
                      </ng-template>
                      <p class="document-info--container__Desc file_name">{{ fileDetails?.name }}</p>
                    </div>
                  } @else {
                    <div class="ownership-document--body">
                      <p class="no-file text-danger">File is yet to upload</p>
                    </div>
                  }
                  <ng-template #noFileMessage>
                    <div class="ownership-document--body">
                      <p class="no-file text-danger">File is yet to upload</p>
                    </div>
                  </ng-template>
                  <section class="auditLog_view">
                    <div class="esign-info" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                      [infiniteScrollThrottle]="500" (scrolled)="onScrolled()">
                      <table class="table" aria-label="eSignDetails">
                        <thead>
                          <tr>
                            <th class="document-info--container__Date">Date</th>
                            <th class="document-info--container__Name">Logs</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (item of updateHistory; track item) {
                            <tr>
                              <td class="document-info--container__Date">
                              {{item?.created | date:"dd MMM yy, hh:mm a"}}</td>
                              @if (item?.formatedMessage) {
                                <td class="document-info--container__Name" [innerHTML]="item?.formatedMessage"></td>
                              } @else {
                                <td class="document-info--container__Name">
                                  {{ item?.message }} {{ item?.userDetails.name }}
                                  @if (item?.reason) {
                                    <span>
                                      <span class="message">with reason</span> {{ item?.reason }}
                                    </span>
                                  }
                                </td>
                              }
                              <ng-template #normalMessage>
                                <td class="document-info--container__Name">
                                  {{ item?.message }} {{ item?.userDetails.name }}
                                  @if (item?.reason) {
                                    <span>
                                      <span class="message">with reason</span> {{ item?.reason }}
                                    </span>
                                  }
                                </td>
                              </ng-template>
                            </tr>
                          }
                          @if (!updateHistory || updateHistory.length === 0) {
                            <tr>
                              <td class="document-info--container__Name text-center text-danger" colspan="2">
                                No data found
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            @if (materialList?.remarks) {
              <div class="view-register-details__DescriptionWrapper">
                <div class="view-register-details__DescriptionContainer">
                  <div class="row d-flex justify-content-between border-bottom">
                    <div class="col-md-5 view-register-details__DescriptionHeader mb-2">
                      Remarks
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <p class="view-register-details__detailscardfieldheading remarks-text">
                        {{ materialList?.remarks || '-' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (materialList?.status !== 'Pending Document Upload' && materialList?.status !== 'Pending OCR Validation') {
              <div class="view-register-details__DescriptionWrapper"
                >
                <div class="view-register-details__DescriptionContainer">
                  <div class="d-flex  border-bottom">
                    <span class="view-register-details__DescriptionHeader mb-2">
                      Validation Details
                    </span>
                    <p class="note-text">
                      (* Modified fields are highlighted in <span class="note-update">orange</span> color)
                    </p>
                  </div>
                  <div class="update-history">
                    @if (materialList?.status === 'Completed' || materialList?.status === 'Pending Correction') {
                      <section class="updated_history_view">
                        @if (materialList?.status === 'Completed' || materialList?.status === 'Pending Correction') {
                          <div class="esign-info extract" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                            [infiniteScrollThrottle]="500" (scrolled)="onScrolling()"
                            >
                            <table class="table" aria-label="eSignDetails">
                              <thead>
                                <tr>
                                  @for (header of tableData.headers; track header) {
                                    <th class="document-info--container__Name">{{ header }}</th>
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                @for (row of tableData.data; track row) {
                                  @if (row.isGroupRow) {
                                    <tr class="group-header-row">
                                      <td class="document-info--container__Name" colspan="6"><strong>{{ row.lrNumber }}</strong></td>
                                    </tr>
                                  }
                                  <tr>
                                    <td class="document-info--container__Name"></td>
                                    <td class="document-info--container__Name">{{ row.field || '-' }}</td>
                                    <td class="document-info--container__Name" [ngClass]="{'update' : row.isUpdated === true}">{{ row.expected || '-' }}</td>
                                    <td class="document-info--container__Name">{{ row.extracted || '-' }}</td>
                                    <td class="document-info--container__Name">{{ row.pageNumber || '-' }}</td>
                                <td class="document-info--container__Name" [ngClass]="{
                                    'status-pass': row.status === 'Match' && row.expected !== ' - ' && row.extracted !== ' - ',
                                    'status-fail': row.status === 'Mismatch'
                                  }">
                                      {{ row.status || ' - ' }}
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        }
                      </section>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      @if (isUploadDocuments) {
        <app-material-upload [materialData]="selectedMaterial" (successMessage)="onUploadSuccess($event)"
        (closeOverlay)="closeUploadOverlay()"></app-material-upload>
      }
      <ng-template #documentModal let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Document Preview</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body modal-container">
          <!-- Left Section: Document Preview -->
          <div class="document-preview">
            @if (materialList?.isPdf) {
              <iframe [src]="materialList.documentThumbnailUrl" class="document-frame" title="Document Preview">
                This browser does not support PDFs. <a [href]="materialList.documentThumbnailUrl" target="_blank">Download PDF</a>
              </iframe>
            }

            @if (!materialList?.isPdf && materialList?.documentThumbnailUrl && !loader) {
              <img
                [src]="materialList.documentThumbnailUrl" alt="Document Preview" class="document-image" />
            }

            @if (!materialList?.documentThumbnailUrl && !loader) {
              <div class="no-preview">
                <img src="../../../assets/Images/document-preview/Files.svg" class="ownership-document--body__Image" alt="Default Document Icon">
                <p class="document-info--container__Desc file_name">No preview available</p>
              </div>
            }
            @if (loader) {
              <div class="text-danger loader">
                <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
              </div>
            }
          </div>

          <div class="document-info">
            <div>
              <div class="document-info--container">
                <div class="document-info--container__Name">Name</div>
                <div class="document-info--container__Desc" data-bs-toggle="tooltip" placement="top">
                  <span class="span-space">: </span>{{fileDetails?.name}}
                </div>
              </div>
              <div class="document-info--container">
                <div class="document-info--container__Name">Total Size</div>
                <div class="document-info--container__Desc"><span class="span-space">: </span>{{(this.fileDetails?.fileSize | storageFormat)}}</div>
              </div>
              <div class="document-info--container">
                <div class="document-info--container__Name">File Type</div>&nbsp;
                <div class="document-info--container__Desc"><span class="span-space">: </span>{{getFileType(fileDetails?.mimeType)}}</div>
              </div>
            </div>
            <br>
              <section>
                <div class="audit-information">Audit Log</div>
                <br>
                  <div class="esign-info" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                    [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
                    <table class="table" aria-label="eSignDetails">
                      <thead>
                        <tr>
                          <th class="document-info--container__Name">Date</th>
                          <th class="document-info--container__Name">Logs</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of inboundLog; track item) {
                          <tr>
                            <td class="document-info--container__Name">
                            {{item?.created | date:"dd MMM yy, hh:mm a"}}</td>
                            <td class="document-info--container__Name">{{item?.message}}
                              {{item?.userDetails.name}}
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </div>
          </ng-template>
          @if (isSuccessToster) {
            <div >
              <app-toast [title]="message" (closeToaster)="closeToster($event)"></app-toast>
            </div>
          }
          @if (isErrorToster) {
            <div>
              <app-error-toaster [title]="errorMessage" (closeToaster)="closeToster($event)"></app-error-toaster>
            </div>
          }
